import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[] | null;
    isLoading: boolean;
    isError: boolean;
    isHoliday: boolean;
    hideLayersBox?: boolean;
    seenOfferIds?: number[];
}

export const OfferListMap = (props: IProps) => {
    const {offers, isLoading, isError} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(() => {
        return offers || [];
    });
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);
    const prevOfferIds = useRef<number[]>([]);

    useEffect(() => {
        const currentOfferIds = offers?.map((offer) => offer.id).sort() || [];
        const offersChanged = !isEqual(prevOfferIds.current, currentOfferIds);
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;
        const offersSuccess = !isLoading && !isError;

        if (props.isHoliday && offersSuccess && offersChanged) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }

        if (!props.isHoliday && offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }
    }, [props.isHoliday, isLoading, isError, isRegionRequestSucceeded, offers, regionData, prevRegionRequestState]);

    const markersLength = props.offers?.length || 0;

    return (
        <>
            {(!markersLength || isError) && (
                <div className={emptyListMap}>
                    <section className={emptyListSection}>
                        <div className={emptyListContent}>
                            {isError ? (
                                <Text as="p" variant="headline_5" className={emptyListMessage}>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </Text>
                            ) : (
                                <Text as="p" variant="headline_5" className={emptyListMessage}>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </Text>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
                seenOfferIds={props.seenOfferIds}
            />
        </>
    );
};

const emptyListMap = css({
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    backgroundImage: `url(${mapBg})`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 2rem"
});

const emptyListSection = css({
    textAlign: "center"
});

const emptyListContent = css({
    width: "100%",
    textAlign: "center"
});

const emptyListMessage = css({
    margin: 0
});
import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {usePrevious} from "@pg-mono/hooks";
import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[] | null;
    isLoading: boolean;
    isError: boolean;
    isHoliday: boolean;
    hideLayersBox?: boolean;
    seenOfferIds?: number[];
}

export const OfferListMap = (props: IProps) => {
    const {offers, isLoading, isError} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(() => {
        return offers || [];
    });
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);
    const prevOfferIds = useRef<number[]>([]);

    useEffect(() => {
        const currentOfferIds = offers?.map((offer) => offer.id).sort() || [];
        const offersChanged = !isEqual(prevOfferIds.current, currentOfferIds);
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;
        const offersSuccess = !isLoading && !isError;

        if (props.isHoliday && offersSuccess && offersChanged) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }

        if (!props.isHoliday && offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
            setStateOffers(offers || []);
            setStateRegionData(regionData?.results || []);
            prevOfferIds.current = currentOfferIds;
        }
    }, [props.isHoliday, isLoading, isError, isRegionRequestSucceeded, offers, regionData, prevRegionRequestState]);

    const markersLength = props.offers?.length || 0;

    return (
        <>
            {(!markersLength || isError) && (
                <div className={emptyListMap}>
                    <section className={emptyListSection}>
                        <div className={emptyListContent}>
                            {isError ? (
                                <Text as="p" variant="headline_5" className={emptyListMessage}>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </Text>
                            ) : (
                                <Text as="p" variant="headline_5" className={emptyListMessage}>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </Text>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
                seenOfferIds={props.seenOfferIds}
            />
        </>
    );
};

const emptyListMap = css({
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    backgroundImage: `url(${mapBg})`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 2rem"
});

const emptyListSection = css({
    textAlign: "center"
});

const emptyListContent = css({
    width: "100%",
    textAlign: "center"
});

const emptyListMessage = css({
    margin: 0
});
